<template>
  <div class="itemBox">
    <div class="docker">
      <div v-if="item.isDocker && item.moduleMode == 0">
        <img src="@/assets/docker.png" style="margin-top: 12px;position:absolute;display: flex;flex-direction: column;justify-content: center;align-items: center;
          margin-left:8px;width: 25px;height: 25px;">
        <img src="@/assets/butel.png" style="margin-top: 30px;position:absolute;display: flex;flex-direction: column;justify-content: center;align-items: center;
          width: 40px;height: 40px;">
      </div>
      <div v-else-if="!item.isDocker && item.moduleMode == 0">
        <img src="@/assets/butel.png" style="margin-top: 16px;display: flex;justify-content: center;align-items: center;
          width: 40px;height: 40px;vertical-align: center">
      </div>
      <div v-else-if="item.isDocker && item.moduleMode == 1">
        <img src="@/assets/docker.png" style="margin-top: 20px;position:absolute;display: flex;flex-direction: column;justify-content: center;align-items: center;
           vertical-align: center;margin-left:8px;width: 25px;height: 25px;">
      </div>
    </div>
    <div class="online">
      <div v-if="item.isOnline">
        <img src="@/assets/run.gif" style="width: 25px;height: 25px;margin-top:20px">
      </div>
    </div>
    <div class="num">{{ item.id }}</div>
    <div class="name" :title="item.name">{{ item.name }}</div>
    <div class="intergration" :title="item.integrationVersionAlias">{{ item.integrationVersionAlias }}</div>
    <div class="alias" :title="item.alias" style="margin-right: 10px">{{ item.alias }}</div>
    <div class="deviceName" :title="item.deviceName">{{ item.deviceName }}</div>
    <div class="moduleType">{{ item.moduleType }}</div>
    <div class="moduleVersion" :title="item.moduleVersion">{{ item.moduleVersion }}</div>
    <div class="statusDesc">
      <el-popover trigger="click" @show="showStatusProcess = true" @hide="showStatusProcess = false">
        <!-- <div>
          <span>显示当前进度</span>
        </div> -->
        <instance-operate-status v-if="showStatusProcess" :activeItem="status" />
        <span slot="reference">{{ statusDesc({ service: item }) }}</span>
      </el-popover>
    </div>
    <div class="resultDesc">
      <el-tooltip :content="item.status.description" effect="light" placement="left-start">
        <span>{{ item.status.description }}</span>
      </el-tooltip>
    </div>
    <div class="operate" v-if="item.operate && listOperations.length > 0">操作</div>
    <div class="operate" v-if="showOperate && listOperations.length > 0">

      <!-- 按钮平铺 -->
      <!-- <div class="operate_btn">
        <el-button size="mini" type="primary" @click="showEdit = true">编辑</el-button>
        <el-button size="mini" type="primary" @click="showConfig=true">配置文件列表</el-button>

        <el-button
          size="mini"
          @click="showDepend=true"
          type="primary"
          v-if="item.status.operation.create == 1
                && item.status.operation.allocate != 1"
          :disabled="item.status.operation.dependency == 0"
        > {{item.editDep ? '编辑依赖' : '建立依赖'}}</el-button>

        <el-button size="mini" type="primary" @click="instanceDownload"
          v-if="item.status.operation.create == 1
                && item.status.operation.allocate != 1
                && item.status.operation.download != 1"
          :disabled="item.status.operation.download == 0"
        > 下载
        </el-button>

        <el-button size="mini" type="primary" @click="showSource = true; isReset = false"
          v-if="(item.status.operation.create == 1)
                 && item.status.operation.allocate != 1
                 && item.status.operation.register != 1
                 && item.status.operation.release != 1"
          :disabled="item.status.operation.register == 0"
        >分配资源
        </el-button>

        <el-button size="mini" type="primary" @click="reSetResource"
          v-if="showRelease || (item.status.operation.release == 1
                                && item.status.operation.allocate != 1
                                && item.status.operation.register != 1)"
          :disabled="status == 'releaseResource' && value == 'running'"
        >重配资源
        </el-button>
        <el-button size="mini" type="danger"
          v-if="item.status.operation.release == 1"
          :disabled="item.status.operation.release == 0"
          @click="delConfirm">删除</el-button>

        <el-button
          size="mini"
          @click="zipFiles"
          type="primary"
          v-if="item.status.operation.create == 2"
          :disabled="item.status.operation.create == 0"
        >打包</el-button>

        <el-button
          size="mini"
          @click="allocate"
          type="primary"
          v-if="item.status.operation.dependency == 1 &&
                item.status.operation.download == 1 &&
                item.status.operation.register == 1 &&
                item.status.operation.allocate != 1"
          :disabled="item.status.operation.allocate == 0"
        >配置</el-button>

        <el-button
          size="mini"
          @click="installOrUninstall('install')"
          type="primary"
          v-if="(item.status.operation.allocate == 1
                  || item.status.operation.uninstall == 1)
                && item.status.operation.install != 1"

          :disabled="status == 'install' && value == 'running'"
        >安装
        </el-button>

        <el-button
          size="mini"
          @click="installOrUninstall('uninstall')"
          type="primary"
          v-if="item.status.operation.install == 1 && item.status.operation.uninstall !=1"

          :disabled="item.status.operation.uninstall == 0"
        >卸载
        </el-button>
        <el-dropdown trigger="click">
          <el-button type="primary" size="mini">重置</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 7)">创建实例</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 8)">建立依赖</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 19)">下载实例</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 18)">分配资源</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 17)">释放资源</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 9)">配置</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 2)">安装</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 3)">卸载</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown trigger="click">
          <el-button type="primary" size="mini">更多</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button size="mini" type="primary" @click="goDepended">被依赖查询</el-button>
            </el-dropdown-item>

            <el-dropdown-item>
              <el-button size="mini" type="primary" @click="moduleUpdate">模块更新</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </div>
      </div> -->
      <!-- icon按钮 -->
      <!-- <div class="operate_btn">
        <img src="@/assets/edit.png" title="编辑" @click="showEdit = true" />
        <img src="@/assets/files.png" title="配置文件列表" @click="showConfig=true" />

        <img @click="showDepend=true" src="@/assets/depend.png"
          v-if="item.status.operation.create == 1
                && item.status.operation.allocate != 1"
          :disabled="item.status.operation.dependency == 0"
          :title="item.editDep ? '编辑依赖' : '建立依赖'"
        />

        <img @click="instanceDownload" src="@/assets/download.png"
          v-if="item.status.operation.create == 1
                && item.status.operation.allocate != 1
                && item.status.operation.download != 1"
          :disabled="item.status.operation.download == 0"
          title="下载"
         />

        <img @click="showSource = true; isReset = false"
          v-if="(item.status.operation.create == 1)
                 && item.status.operation.allocate != 1
                 && item.status.operation.register != 1
                 && item.status.operation.release != 1"
          :disabled="item.status.operation.register == 0"
          title="分配资源"
          src="@/assets/setresource.png"
         />

        <img @click="reSetResource"
          v-if="showRelease || (item.status.operation.release == 1
                                && item.status.operation.allocate != 1
                                && item.status.operation.register != 1)"
          :disabled="status == 'releaseResource' && value == 'running'"
          title="重配资源"
          src="@/assets/setresource.png"
        >

        <img
          src="@/assets/del.png"
          v-if="item.status.operation.release == 1"
          :disabled="item.status.operation.release == 0"
          @click="delConfirm"
          title="删除">

        <el-button
          size="mini"
          @click="zipFiles"
          type="primary"
          v-if="item.status.operation.create == 2"
          :disabled="item.status.operation.create == 0"
        >打包</el-button>

        <img src="@/assets/peizhi.png"
          v-if="item.status.operation.dependency == 1 &&
                item.status.operation.download == 1 &&
                item.status.operation.register == 1 &&
                item.status.operation.allocate != 1"
          :disabled="item.status.operation.allocate == 0"
          title="配置"
        >

        <img src="@/assets/isntall.png"
          @click="installOrUninstall('install')"
          v-if="(item.status.operation.allocate == 1
                  || item.status.operation.uninstall == 1)
                && item.status.operation.install != 1"

          :disabled="status == 'install' && value == 'running'"
          title="安装"
        >

        <img src="@/assets/uninstall.png"
          @click="installOrUninstall('uninstall')"
          v-if="item.status.operation.install == 1 && item.status.operation.uninstall !=1"

          :disabled="item.status.operation.uninstall == 0"
          title="卸载"
        >
        <el-dropdown trigger="click">
          <el-button size="mini" style="padding: 0;border: none;" title="重置">
            <img src="@/assets/reset.png" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 7)">创建实例</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 8)">建立依赖</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 19)">下载实例</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 18)">分配资源</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 17)">释放资源</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 9)">配置</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 2)">安装</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button type="primary" size="mini" @click="reset(item, 3)">卸载</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <img src="@/assets/depended.png"
          @click="goDepended"
          title="被依赖查询"
        >
        <img src="@/assets/moduleupdate.png"
          @click="moduleUpdate"
          title="模块更新"
        >

        </div>
      </div> -->

      <!-- 折叠按钮 -->
      <div class="operate_btn">
        <!--        操作盘按钮-->
        <el-button v-if="operationItem('panel').length > 0" style="margin-right: 5px" size="mini" type="primary"
          title="操作盘" @click="showPanelBox">
          <i class="el-icon-s-tools"></i>
        </el-button>

        <!--重置按钮-->
        <el-dropdown trigger="click" v-if="operationItem('reset').length > 0">
          <el-button type="primary" size="mini" title="重置" style="margin-right: 5px">
            <i class="el-icon-refresh-left"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_create')">
              <el-button type="primary" size="mini" @click="reset(item, 7)">创建实例</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_dependency')">
              <el-button type="primary" size="mini" @click="reset(item, 8)">建立依赖</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_download')">
              <el-button type="primary" size="mini" @click="reset(item, 19)">下载实例</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_reallocateResource')">
              <el-button type="primary" size="mini" @click="reset(item, 18)">分配资源</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_release')">
              <el-button type="primary" size="mini" @click="reset(item, 17)">释放资源</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_config')">
              <el-button type="primary" size="mini" @click="reset(item, 9)">配置</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_install')">
              <el-button type="primary" size="mini" @click="reset(item, 2)">安装</el-button>
            </el-dropdown-item>
            <el-dropdown-item v-if="inOperationItem('reset', 'instanceList_reset_uninstall')">
              <el-button type="primary" size="mini" @click="reset(item, 3)">卸载</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!--更多按钮-->
        <el-dropdown trigger="click" v-if="operationItem('more').length > 0">
          <el-button type="primary" size="mini" title="更多">
            <i class="el-icon-more"></i>
          </el-button>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_edit')">
              <el-button size="mini" type="primary" @click="showEdit = true">编辑</el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_configList')">
              <el-button size="mini" type="primary" @click="showConfig = true">配置文件列表</el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="item.status.operation.create == 1
              && item.status.operation.allocate != 1 && inOperationItem('more', 'instanceList_more_dependency')">
              <el-button size="mini" @click="showDepend = true" type="primary"
                :disabled="item.status.operation.dependency == 0"> {{ item.editDep ? '编辑依赖' : '建立依赖' }}
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="item.status.operation.create == 1
              && item.status.operation.allocate != 1
              && item.status.operation.download != 1
              && inOperationItem('more', 'instanceList_more_download')">
              <el-button size="mini" type="primary" @click="instanceDownload"
                :disabled="item.status.operation.download == 0"> 下载
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_register')
              && (item.status.operation.create == 1)
              && item.status.operation.allocate != 1
              && item.status.operation.register != 1
              && item.status.operation.release != 1">
              <el-button size="mini" type="primary" @click="showSource = true"
                :disabled="item.status.operation.register == 0">分配资源
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_register') &&
              (showRelease || (item.status.operation.release == 1
                && item.status.operation.allocate != 1
                && item.status.operation.register != 1))">
              <el-button size="mini" type="primary" @click="reSetResource"
                :disabled="status == 'releaseResource' && value == 'running'">重配资源
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item
              v-if="inOperationItem('more', 'instanceList_more_del') && item.status.operation.release == 1">
              <el-button size="mini" type="danger" :disabled="item.status.operation.release == 0" @click="delConfirm">删除
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item
              v-if="inOperationItem('more', 'instanceList_more_pack') && item.status.operation.create == 2">
              <el-button size="mini" @click="zipFiles" type="primary" :disabled="item.status.operation.create == 0">打包
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_config') &&
              item.status.operation.dependency == 1 &&
              item.status.operation.download == 1 &&
              item.status.operation.register == 1 &&
              item.status.operation.allocate != 1">
              <el-button size="mini" @click="beforeAllocate" type="primary"
                :disabled="item.status.operation.allocate == 0">配置
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_install') &&
              (item.status.operation.allocate == 1 || item.status.operation.uninstall == 1)
              && item.status.operation.install != 1">
              <el-button size="mini" @click="installOrUninstall('install')" type="primary"
                :disabled="status == 'install' && value == 'running'">安装
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_uninstall')
              && item.status.operation.install == 1
              && item.status.operation.uninstall != 1">
              <el-button size="mini" @click="installOrUninstall('uninstall')" type="primary"
                :disabled="item.status.operation.uninstall == 0">卸载
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_query')">
              <el-button size="mini" type="primary" @click="goDepended">被依赖查询</el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_update')">
              <el-button size="mini" type="primary" @click="getNodeId">模块更新</el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_viewResource')">
              <el-button size="mini" type="primary" @click="showSource = true; resourceDetail = true">查看资源
              </el-button>
            </el-dropdown-item>

            <el-dropdown-item v-if="inOperationItem('more', 'instanceList_more_viewDependency')">
              <el-button size="mini" type="primary" @click="showDependencyDetail = true">查看依赖
              </el-button>
            </el-dropdown-item>
            <!-- <el-dropdown-item v-if=" inOperationItem('more', 'panel')">
              <el-button
                size="mini"
                type="primary"
                @click="showPanelBox">操作盘</el-button>
            </el-dropdown-item> -->

          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>



    <!--    , 内网IP:${innerIp}, 外网IP:${wanIp}`-->
    <el-drawer v-if="showPanel" direction="ttb" size="36%"
      :title="`实例ID: ${item.id}, 模块类型: ${item.moduleType}, 模块版本号: ${item.moduleVersion}, 服务名: ${item.service.name}`"
      :visible.sync="showPanel" :modal="false" :close-on-press-escape="false" :wrapperClosable="true">
      <instance-panel ref="instancepanel" :instance="item" :editStatus="editStatus" @getIp="getIp"
        @editInstance="showEdit = true" @download="instanceDownload" @dependency="showDepend = true"
        @register="showSource = true" @allocate="allocate" @install="installOrUninstall('install')"
        @reSetResource="reSetResource" @showConfigDialog="showConfig = true" @delConfirm="delConfirm"
        @uninstall="installOrUninstall('uninstall')" @moduleUpdate="moduleUpdate"
        @showDependency="showDependencyDetail = true" @resourceDetail="showSource = true; resourceDetail = true"
        @release="releaseResource" @start="start('start')" @stop="start('stop')" @heartbeat="start('connect')"
        @disconnect="start('disconnect')" />
    </el-drawer>

    <detect-result :results="detectResults" :visible="showDetectResult" @closeBox="showDetectResult = false" />

    <el-dialog title="以下配置文件不一致" :visible="showDifferentConfigs" @close="showDifferentConfigs = false">
      <el-row v-for="(con, index) in configsDifferent" :key="index">
        <div>
          <el-col :span="6">
            <h3>{{ con.moduleType }}</h3>
          </el-col>
          <el-col :span="18">
            <h3>{{ con.moduleVersion }}</h3>
          </el-col>
        </div>

        <div v-for="(file, idx) in con.modulesFiles" :key="idx">
          <el-col :span="6">{{ file.fileName }}</el-col>
          <el-col :span="18">{{ file.location }}</el-col>
        </div>
      </el-row>
    </el-dialog>

    <depend v-if="showDepend" :visible="showDepend" :instanceId="item.id" :module="item.moduleType"
      :isEdit="item.editDep" :instanceInfo="item" @dependCallback="dependCallback" />

    <instance-edit v-if="showEdit" :id="item.id" :isEdit="true" :visible="showEdit" :installSuccess="installSuccess"
      @instanceEditCallback="instanceEditCallback" />

    <el-dialog title="配置文件列表" v-if="showConfig" :visible="showConfig" @close="showConfig = false" width="80%">
      <config-list :moduleInfo="moduleInfo" :instanceid="item.id" :docker="item.isDocker"
        :serviceName="item.service.name" />
    </el-dialog>

    <set-source ref="setResourceRef" v-if="showSource" :visible="showSource" :deviceId="item.deviceId"
      :module="item.moduleType" :moduleVersion="item.moduleVersion" :isReset="isReset" :instanceId="item.id"
      :hasServiceHelper="item.hasServiceHelper" :resourceId="item.resource.id" :resourceDetail="resourceDetail"
      :registered="registered" @sourceCallback="sourceCallback" />

    <dependency-detail v-if="showDependencyDetail" :visible="showDependencyDetail" :instanceInfo="item"
      @closeDependencyDetail="showDependencyDetail = false" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Loading } from "element-ui";
import Depend from "./Dependency.vue";
import InstanceEdit from "./InstanceEdit";
import ConfigList from "./ConfigList";
import SetSource from './SetSource.vue';
import InstanceOperateStatus from './common/InstanceOperateStatus'
import DependencyDetail from "./DependencyDetail"
import InstancePanel from "./InstancePanel"
import DetectResult from "@/components/device/DeviceDetectResult"

export default {
  components: {
    Depend, InstanceEdit, ConfigList, SetSource,
    InstanceOperateStatus, DependencyDetail, InstancePanel, DetectResult
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: {}
    },
    index: {
      type: [String, Number]
    },
    showOperate: {
      type: Boolean,
      default: true
    },
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    }
  },
  data: vm => ({
    editStatus: null, //编辑实例状态:null, 'success'
    showPanel: false, //操作盘
    showDepend: false,
    showEdit: false,
    showConfig: false,
    showSource: false,
    moduleInfo: {
      id: "",
      name: "",
      version: ""
    },
    showStatusProcess: false,
    isReset: false, //是否是重新分配资源
    resourceDetail: false, //是否是查看资源
    // installSuccess: false, //实例是否安装成功
    showDependencyDetail: false, //查看依赖
    detectResults: [],//启动前端口探测结果
    showDetectResult: false,
    configsDifferent: [],
    showDifferentConfigs: false,
    registered: false,
    innerIp: "",
    wanIp: "",

  }),
  computed: {
    // 实例是否安装成功
    installSuccess() {
      return this.item.status.operation.install == 1
    },
    filterStatusDesc() {
      if (this.item.statusDesc) {
        return this.item.statusDesc;
      }
      // if(this.item.status.description){
      //     return this.item.status.description
      // }
      let progressName = "";
      let valueDesc = "";
      switch (this.item.status.progress) {
        case 7:
          progressName = "创建";
          break;
        case 8:
          progressName = "建立依赖";
          break;
        case 9:
          progressName = "配置";
          break;
        case 0:
          progressName = "安装发送";
          break;
        case 1:
          progressName = "下载";
          break;
        case 2:
          progressName = "安装";
          break;
        case 3:
          progressName = "卸载";
          break;
        case 4:
          progressName = "启动";
          break;
        case 5:
          progressName = "停止";
          break;
        case 6:
          progressName = "心跳连接";
          break;
        case 10:
          progressName = "心跳中断";
          break;
        case 11:
          progressName = "启动发送";
          break;
        case 12:
          progressName = "停止发送";
          break;
        case 13:
          progressName = "心跳连接发送";
          break;
        case 14:
          progressName = "心跳中断发送";
          break;
        case 15:
          progressName = "卸载发送";
          break;
        case 16:
          progressName = "卸载备份";
          break;
        case 17:
          // 释放资源
          progressName = "释放资源";
          break;
        case 18:
          // 分配资源
          progressName = "分配资源";
          break;
        case 19:
          // 实例下载
          progressName = "实例下载";
          break;
        default:
          progressName = "创建";
      }

      switch (this.item.status.value) {
        case 0:
          valueDesc = "进行中";
          break;
        case 1:
          valueDesc = "成功";
          break;
        case 2:
          valueDesc = "失败";
          break;
      }
      return progressName + valueDesc;
    },
    status() {
      let progressName
      switch (this.item.status.progress) {
        case 7:
          progressName = "create";
          break;
        case 8:
          progressName = "depend";
          break;
        case 9:
          progressName = "deploy";
          break;
        case 0:
          progressName = "install_send";
          break;
        case 1:
          progressName = "download";
          break;
        case 2:
          progressName = "install";
          break;
        case 3:
          progressName = "uninstall";
          break;
        case 4:
          progressName = "start";
          break;
        case 5:
          progressName = "stop";
          break;
        case 6:
          progressName = "heartConnect";
          break;
        case 10:
          progressName = "heartBreak";
          break;
        case 11:
          progressName = "start_send";
          break;
        case 12:
          progressName = "stop_send";
          break;
        case 13:
          progressName = "heartConnect_send";
          break;
        case 14:
          progressName = "heartBreak_send";
          break;
        case 15:
          progressName = "uninstall_send";
          break;
        case 16:
          progressName = "uninstall_clone";
          break;
        case 17:
          // 释放资源
          progressName = "releaseResource";
          break;
        case 18:
          // 分配资源
          progressName = "setResource";
          break;
        case 19:
          // 实例下载
          progressName = "instancedownload";
          break;
        default:
          progressName = "create";
      }
      return progressName
    },
    value() {
      let val
      switch (this.item.status.value) {
        case 1:
          val = 'success';
          break;
        case 2:
          val = 'failed';
          break;
        case 0:
          val = 'running';
          break;
      }
      return val
    },
    // 释放资源
    showRelease() {
      let showFlag = false
      // 分配资源
      if (this.item.status.operation.register == 1) {
        showFlag = true
      }
      // 配置
      if (this.item.status.operation.allocate == 1) {
        showFlag = false
      }
      // 卸载 优先级最高
      if (this.item.status.operation.uninstall == 1) {
        showFlag = true
      }
      // 若正在执行安装操作，不能释放资源
      if (this.status == 'install' && this.value == 'running') {
        showFlag = false
      }
      return showFlag
    },
    ...mapState(['menus', 'listOperations']),

    // 当前操作对象
    operationItem() {
      if (!this.listOperations) {
        return null
      }
      return (field) => {
        return this.listOperations.filter(op => op.name.includes(field))
      }
    },
    // 子操作是否在当前操作里
    inOperationItem() {
      return (field, name) => {
        const item = this.operationItem(field)

        if (!item || item.length == 0 || item[0].buttonList.length == 0) {
          return false
        }
        return item[0].buttonList.some(childFun => childFun.name.includes(name))
      }
    },
  },
  created() {
    this.moduleInfo = {
      name: this.item.moduleType,
      version: this.item.moduleVersion
    };
  },
  methods: {
    getIp() {
      let data = {
        deviceId: this.item.deviceId,
      };
      this.$axios.post(this.baseUrl3 + 'management3/ipinfo/findIpInfoListByDeviceId', data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            if(data.innerIpList && data.innerIpList.length > 0) {
              this.innerIp = data.innerIpList.join(", ");
            }
            if(data.wanIpList && data.wanIpList.length > 0) {
              this.wanIp = data.wanIpList.join(", ");
            }
          } else {
            this.$message.error("获取内外网IP失败！")
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    reset(row, progress) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      // if()
      this.$axios.get(this.baseUrl3 + "instance/reset/status/"
        + row.id + '/'
        + row.status.id + '/'
        + progress + '/'
        + 1)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success('操作成功')
            // this.$emit('itemCallback')
          } else {
            this.$message({ showClose: true, message: msg, type: "error" })
          }
          loading.close()
        }).catch(err => {
          loading.close();
          this.$message.error('请求失败');
          console.log(err)
        });
    },
    // 删除
    del() {
      this.$axios.get(this.baseUrl3 + "instance/del/" + this.item.id)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success('操作成功');
            this.$emit('itemCallback');
            this.showPanel = false //关闭操作盘
          } else {
            this.$message({ showClose: true, message: msg, type: "error" })
          }
        }).catch(err => {
          this.$message.error('请求失败');
          console.log(err)
        });
    },
    delConfirm() {
      this.$confirm('您将删除该实例, 请确认是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.del()
      }).catch(() => {

      });
    },
    releaseRequest() {
      this.$axios.get(this.baseUrl3 + "instance/release/resource/" + this.item.id)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success('操作成功')
          } else {
            this.$message({ showClose: true, message: msg, type: "error" })
          }
        }).catch(err => {
          this.$message.error('请求失败');
          console.log(err)
        });
    },
    // // 释放资源
    releaseResource() {
      let _this = this;
      this.$confirm('您确定要释放资源吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.releaseRequest()
      }).catch(() => {
      });
    },
    // 重配资源
    reSetResource() {
      if (this.item.status.operation.release != 1) {
        this.isReset = true
      } else {
        this.isReset = false;
        this.registered = true
      }

      this.showSource = true
    },
    sourceCallback(val) {
      if (val != false) {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        // 创建实例
        let model = {
          content: val,
          id: this.item.resource.id
        };
        let _this = this;
        this.$axios.post(this.baseUrl3 + "instance/register/resource", model)
          .then(({ data: { msg, data, code } }) => {
            if (code == 20000) {
              this.$message.success('操作成功');
              // this.showSource = false
              // console.log(_this.$refs)
              // console.log(_this.$refs.instancepanel)
              // _this.$refs.instancepanel.getNodeId();
            } else {
              this.$message({ showClose: true, message: msg, type: "error" });
              console.log(msg);
            }
            loading.close();
          }).catch(err => {
            this.$message.error('操作失败');
            loading.close();
          });
      }
      // else{
      //   this.showSource = false
      //   this.resourceDetail = false
      // }
      this.showSource = false;
      this.isReset = false;
      this.resourceDetail = false
    },
    dependCallback(val) {
      this.showDepend = false;
      // if(val == true){
      //   this.$emit('itemCallback')
      // }
    },
    beforeAllocate() {
      if (this.item.service.serviceMode) {
        this.allocate();
      } else {
        this.findById();
      }
    },
    findById() {
      if (!this.item.id) {
        return
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + "instance/findById/" + this.item.id)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            if (data.containerId) {
              this.allocate();
            } else {
              this.showEdit = true;
            }
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close();
        }).catch(err => {
          loading.close();
        })
    },
    // 配置
    allocate() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios
        .get(this.baseUrl3 + "instance/allocate/" + this.item.id)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success("操作成功");
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close();
        })
        .catch(error => {
          loading.close();
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    // 打包
    zipFiles() {
      this.$message("正在开发。。");
    },
    installOrUninstall(type) {
      if (this.item.progs && this.item.progs.length > 0) {
        this.$set(this.item, "progs", []);
      }
      this.$axios
        .get(this.baseUrl3 + "deploy/" + type + "/" + this.item.id)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success("下发任务成功");
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    // 实例下载
    instanceDownload() {
      this.$axios
        .get(this.baseUrl3 + "instance/download/deploy/" + this.item.id)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.$message.success("下载成功");
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: "系统异常",
            type: "error"
          });
          console.log(error);
        });
    },
    // 跳转到被依赖查询页面
    goDepended() {
      const param = Object.assign({}, this.item, { currentPage: this.currentPage });
      this.$router.push({
        name: 'deploydepended',
        params: param
      })
    },
    getNodeId() {
      let data = {
        instanceId: this.item.id,
        moduleType: this.item.moduleType
      }
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/findByInsId', data)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            _this.moduleUpdate();
            // if(data && data.nodeId){
            //   _this.moduleUpdate();
            // } else {
            //   this.$message.warning('当前实例未绑定业务ID！')
            // }
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 模块更新
    moduleUpdate() {
      this.$router.push({
        name: 'deployinstancemoduleupdate',
        params: {
          id: this.item.id, //实例id
          docker: this.item.isDocker, //是否docker
          isInstall: this.item.service.status.operation.install, //是否docker
          serviceName: this.item.service.name, //服务名称
          moduleType: this.item.moduleType, // 模块类型
          moduleVersion: this.item.moduleVersion, // 模块版本
          unitAlias: this.item.integrationVersionAlias, //集成别名
          unitVersion: this.item.integrationVersionVersion, //集成版本
          resourceId: this.item.resource.id,
          deviceId: this.item.deviceId,
          editDep: this.item.editDep, //是否已经建立过依赖
          currentPage: this.currentPage, //当前的页码
        }
      })
    },
    instanceEditCallback(val) {
      this.showEdit = false;
      if (val != false) {
        this.item.alias = val;
        this.editStatus = 'success'
      }
    },
    showPanelBox() {
      this.showPanel = true
      // document.getElementById('instance'+ this.item.id).scrollIntoView()

    },
    start(url) {
      this.$axios
        .get(this.baseUrl3 + 'deploy/' + url + "/" + this.item.id)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            // 展示哪些配置文件不一致
            this.$message.success('下发任务成功')
          } else {
            if (code == 10034) {
              this.detectResults = data;
              this.showDetectResult = true
            } else if (code == 10030 && data && data.length > 0) {
              this.showDifferentConfigs = true;
              this.configsDifferent = data
            }
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          // loading.close();
        })
        .catch(err => {
          // loading.close();
          console.log(err);
        });
    },

  }
};
</script>
<style>
.itemBox {
  padding: 5px 0;
  position: relative;
  font-size: 14px;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
}

.online,
.docker,
.num,
.name,
.alias,
.moduleVersion,
.deviceName,
.moduleType,
.statusDesc,
.resultDesc,
.intergration {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 100%;
  line-height: 66px;
}

/* .operate{
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    height: 100%;
  } */
.docker {
  width: 50px;
  height: 70px;
  vertical-align: center;
  position: relative;
}

.online {
  width: 3%;
}

.num {
  width: 3%;
  text-align: left;
}

.name {
  width: 9%;
}

.alias {
  width: 11%;
}

.deviceName {
  width: 7%;
}

.moduleType {
  width: 11%;
}

.moduleVersion {
  width: 12%;
}

.intergration {
  width: 9%;
}

.operate {
  width: 13%;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  height: 100%;
}

.statusDesc {
  width: 7%;
}

.resultDesc {
  width: 9%;
}

.operate_btn {
  /* display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-align-content: center;
    align-content: space-around;
    align-items: center;
    height: 100%; */

  height: 66px;
  line-height: 66px;
}

.operate_btn>>>.el-button {
  margin-right: 4px !important;
  padding-left: 6px;
  padding-right: 6px;
}

.operate_btn>>>.el-button+.el-button {
  margin: 0;
}


.operate_btn img {
  cursor: pointer;
  width: 20px;
  /* margin: 0 4px; */
}
</style>
